import { render, staticRenderFns } from "./SearchCollapse.vue?vue&type=template&id=79ba4c4c&scoped=true&"
import script from "./SearchCollapse.vue?vue&type=script&lang=js&"
export * from "./SearchCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ba4c4c",
  null
  
)

export default component.exports